import { render, staticRenderFns } from "./InsertToken.view.vue?vue&type=template&id=6943efd6"
import script from "./InsertToken.view.vue?vue&type=script&lang=js"
export * from "./InsertToken.view.vue?vue&type=script&lang=js"
import style0 from "./InsertToken.view.vue?vue&type=style&index=0&id=6943efd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports